export class AreaAtuacaoProcesso{
    id = 0;
    descricao = '';
}